export const getPtoBalanceSettingsState = state => state.lowBalanceSettings.ptoBalance


// WEBPACK FOOTER //
// ./web/js/administration/lowBalanceSettings/pto/selectors.js